/**
 * Client feature flags (CRA).
 * ZRF-WTPB-001 — communications bridge (WhatsApp Tenant Portal Bridge MVP).
 * ZRF-FIN-001 — financials / rent ledger (Financial Center).
 */

const truthy = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes';
};

/**
 * When false: hide Communications nav and block /communications* landlord pages.
 * Public /p/t/:token shells remain routable (token validate comes later).
 */
export const isCommunicationsBridgeEnabled = () =>
  truthy(process.env.REACT_APP_COMMUNICATIONS_BRIDGE_ENABLED);

/**
 * When false (default): hide Financial Center nav and do not mount the shell.
 * Enable locally: REACT_APP_FINANCIALS_ENABLED=true in .env then restart CRA.
 * Existing Financial Reporting (tab 12) is unrelated and stays available.
 */
export const isFinancialsEnabled = () =>
  truthy(process.env.REACT_APP_FINANCIALS_ENABLED);

/**
 * When false (default): hide Google Doc / Drive sync actions in Documents. Matches the backend
 * GOOGLE_WORKSPACE_ENABLED flag; Google connections are not per-landlord yet.
 */
export const isGoogleWorkspaceEnabled = () =>
  truthy(process.env.REACT_APP_GOOGLE_WORKSPACE_ENABLED);

/**
 * When false (default): hide Receipts & bills in Financial Center.
 * Must match backend EXPENSE_CAPTURE_ENABLED (the API answers 404 while that is off).
 */
export const isExpenseCaptureEnabled = () =>
  truthy(process.env.REACT_APP_EXPENSE_CAPTURE_ENABLED);

/**
 * When false (default): hide the QuickBooks preview in Financial Center.
 * Needs the backend FINANCIALS_ENABLED; nothing is sent to QuickBooks yet.
 */
export const isAccountingPreviewEnabled = () =>
  truthy(process.env.REACT_APP_ACCOUNTING_PREVIEW_ENABLED);

export default {
  isCommunicationsBridgeEnabled,
  isFinancialsEnabled,
  isGoogleWorkspaceEnabled,
  isExpenseCaptureEnabled,
  isAccountingPreviewEnabled,
};
